import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlePreview() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold bg-accent-100 text-accent-700 rounded-full mb-4">
            Learn More
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3 font-heading">
            Explore ItaobuySpreadsheet Guides
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            In-depth articles to help you get the most out of the itaobuy spreadsheet system
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all hover:scale-[1.02] no-underline overflow-hidden"
            >
              {/* Article Image */}
              <div className="w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              {/* Content */}
              <div className="flex-1 flex flex-col p-5">
                <span className="inline-block px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-2 w-fit">
                  {article.category}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors font-heading line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.readTime}</span>
                  <span className="inline-flex items-center gap-1 text-primary-500 font-medium whitespace-nowrap">
                    Read More
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}